/**
 * Date helpers for the recepten screens (the "added" and "last cooked" dates).
 *
 * A deliberately separate copy from the agenda's — a module never imports another
 * module's internals (the independence rule) — kept tiny: just the `nl-NL` `Intl`
 * formatter the recipe view needs.
 */

const dateFmt = new Intl.DateTimeFormat('nl-NL', {
  timeZone: 'Europe/Amsterdam',
  day: 'numeric',
  month: 'short',
  year: 'numeric',
});

/** An ISO instant → "3 sep. 2026" — for "toegevoegd op" / "laatst gekookt op". */
export function formatDate(iso: string): string {
  return dateFmt.format(new Date(iso));
}
